// extracted by mini-css-extract-plugin
export default {"mapContainer":"styles_mapContainer__TEaOh","errorBlock":"styles_errorBlock__OHRoi"};